// src/App.js
import React from 'react';
import MonitorFrame from './components/MonitorFrame/MonitorFrame';
import './App.css'; // We can use this for global styles

function App() {
    return (
        <div className="App">
            <MonitorFrame />
        </div>
    );
}

export default App;